import { render, staticRenderFns } from "./hsjrClass.vue?vue&type=template&id=19579eb6&scoped=true"
import script from "./hsjrClass.vue?vue&type=script&lang=js"
export * from "./hsjrClass.vue?vue&type=script&lang=js"
import style0 from "./hsjrClass.vue?vue&type=style&index=0&id=19579eb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19579eb6",
  null
  
)

export default component.exports